export const paginationFlaws = [
  {
    slug: 'PAGINATION_IN_ARGUMENTS',
    meaning: 'Provider pagination controls are ordinary action arguments while pagination features are off.',
    detectionModes: ['classifier'],
    severity: 'medium',
    fixCategories: ['pagination'],
    repairPolicy: 'verified_review',
    verificationBaseMustSucceed: false,
    requiredEvidence: {
      observationIds: {
        type: 'stringArray',
        minItems: 1
      },
      argumentKeys: {
        type: 'stringArray',
        minItems: 1
      },
      providerParameterNames: {
        type: 'stringArray',
        minItems: 1
      },
      paginationFeaturesActive: {
        type: 'boolean',
        const: false
      }
    },
    evidenceAlternatives: [],
    verificationRecipe: ["API `features.limit`/`features.offset` active with key/location; mapper `cursorKey` set top-level; target action's pagination args removed; complete drain with a page limit observed. Require multiple pages only when the result exceeds that limit."],
    legacyCodes: [],
    evidenceRelations: []
  },
  {
    slug: 'PAGINATION_ISSUE',
    meaning: 'Pagination is missing or does not traverse provider pages correctly.',
    detectionModes: ['classifier', 'code'],
    severity: 'high',
    fixCategories: ['pagination'],
    repairPolicy: 'verified_review',
    verificationBaseMustSucceed: false,
    requiredEvidence: {
      observationIds: {
        type: 'stringArray',
        minItems: 1
      }
    },
    evidenceAlternatives: [
      {
        paginationConfigured: {
          type: 'boolean',
          const: false
        },
        paginationArgumentsPresent: {
          type: 'boolean',
          const: false
        },
        nextCursorObserved: {
          type: 'boolean',
          const: true
        }
      },
      {
        paginationConfigured: {
          type: 'boolean',
          const: false
        },
        paginationArgumentsPresent: {
          type: 'boolean',
          const: false
        },
        providerClampObserved: {
          type: 'boolean',
          const: true
        },
        moreDataObserved: {
          type: 'boolean',
          const: true
        }
      },
      {
        paginationConfigured: {
          type: 'boolean',
          const: false
        },
        paginationArgumentsPresent: {
          type: 'boolean',
          const: false
        },
        providerDocumentationUrl: {
          type: 'string'
        },
        runtimePaginationObserved: {
          type: 'boolean',
          const: true
        }
      },
      {
        configPaths: {
          type: 'stringArray',
          minItems: 1
        },
        continuationFailed: {
          type: 'boolean',
          const: true
        }
      }
    ],
    verificationRecipe: ['Configure the provider pagination fields for its offset or cursor contract.', 'Observe a complete drain with a page limit through the real read runtime.', 'Require multiple pages only when the result exceeds that limit.', 'If the provider does not paginate, dismiss with provider_unsupported and record the details.', 'Keep the API and action pagination controls consistent.'],
    legacyCodes: ['PAGINATION_LIMIT_MAX_MISSING', 'PAGINATION_LIMIT_MAX_MISMATCH_PROVIDER_CLAMP', 'PAGINATION_LIMIT_MAX_REJECTED_BY_PROVIDER', 'PAGINATION_CURSOR_CONTRACT_MISMATCH'],
    evidenceRelations: [],
    codeEvidenceAlternatives: [
      {
        configPaths: {
          type: 'stringArray',
          minItems: 1
        },
        continuationFailed: {
          type: 'boolean',
          const: true
        }
      }
    ]
  }
];
